export default __webpack_public_path__ + "bd83782985757d6dd1e7cc22fc4f14ca.png";